


















import Vue from 'vue'
import Carousel from '@/product/components/Carousel.vue'
import CarouselItem from '@/product/components/CarouselItem.vue'
import { CAROUSEL_ITEM_LIMIT } from '@/product/const'
import productServices from '@/product/services'
import { SimilarProducts, SimilarProductItem } from '@/product/types'

export default Vue.extend({
  components:{
    Carousel,
    CarouselItem
  },
  data(): {
    productList: SimilarProductItem[],
    itemTotalCount: number,
  } {
    return {
      productList: [],
      itemTotalCount: 0
    }
  },
  computed: {
    productId(): string{
      return this.$route.params.id
    }
  },
  created() {
    this.getProducts(0, CAROUSEL_ITEM_LIMIT)
  },
  methods: {
    async getProducts(offset: number, limit: number) {
      const data: SimilarProducts = await productServices.getSeriesProducts(
        this.productId,
        offset,
        limit
      )
      if (data) {
        this.productList = data.items as SimilarProductItem[]
        this.itemTotalCount = data.totalItemsCount
      }
    },
    onFetchData({ offset, limit }: {offset: number, limit: number}) {
      this.getProducts(offset, limit)
    }
  }
})
